import { BodyText, Headline, Stack } from '@servicetitan/design-system';
import { FC, ReactNode } from 'react';

export const Done: FC<{
    title: string;
    description: string;
    contentClassName?: string;
    children?: ReactNode;
}> = ({ children, contentClassName, description, title }) => (
    <div>
        <Stack justifyContent="center" className="m-b-2">
            <img src="https://static.servicetitan.com/portal/check.svg" alt="done" />
        </Stack>
        <Headline className="ta-center">{title}</Headline>

        <BodyText className="ta-center m-y-2 c-neutral-200">{description}</BodyText>

        {!!children && <div className={contentClassName}>{children}</div>}
    </div>
);
